import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';
import { getCallStatusFilterOptions } from '../../../lib/utils/callStatus';

const AICallsSearchFilters = ({
  searchInput,
  onSearchInputChange,
  onSearchSubmit,
  dateFilter,
  onDateFilterChange,
  statusFilter = 'all',
  onStatusFilterChange,
  totalCalls,
}) => {
  const { t, i18n } = useTranslation();
  const statusOptions = useMemo(() => getCallStatusFilterOptions(t), [t, i18n.language]);

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 mb-6">
      <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 lg:items-end">
        <div className="flex-1">
          <div className="flex w-full gap-2 items-end">
            <div className="flex-1 min-w-0">
              <Input
                label={t('ai.calls.searchLabel')}
                type="search"
                placeholder={t('ai.calls.searchPlaceholder')}
                value={searchInput}
                onChange={(event) => onSearchInputChange(event?.target?.value ?? '')}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    event.preventDefault();
                    onSearchSubmit?.();
                  }
                }}
                className="w-full"
              />
            </div>
            <Button
              type="button"
              variant="default"
              size="icon"
              iconName="Search"
              onClick={onSearchSubmit}
              aria-label={t('ai.calls.searchAria')}
              className="shrink-0"
            />
          </div>
        </div>

        <div className="w-full lg:w-56">
          <Input
            label={t('ai.calls.filterDate')}
            type="date"
            value={dateFilter}
            onChange={(event) => onDateFilterChange(event?.target?.value ?? '')}
            className="w-full"
          />
        </div>

        <div className="w-full lg:w-56">
          <Select
            label={t('ai.calls.filterStatus')}
            options={statusOptions}
            value={statusFilter}
            onChange={onStatusFilterChange}
            placeholder={t('ai.calls.selectStatus')}
          />
        </div>

        <div className="flex items-center gap-2 text-sm text-muted-foreground bg-muted px-4 py-3 rounded-lg whitespace-nowrap">
          <Icon name="Phone" size={16} />
          <span className="font-medium">{t('ai.calls.totalCalls', { count: totalCalls })}</span>
        </div>
      </div>
    </div>
  );
};

export default AICallsSearchFilters;
